export const enum LogTypes {
  functional = "functional",
  technical = "technical",
  performance = "technical",
  feature = "feature",
}

export const enum LogLevels {
  debug = "debug",
  info = "info",
  warn = "warn",
  error = "error",
  fatal = "fatal",
}

// tslint:disable-next-line:interface-name
export interface LogMessage {
  name: string;
  type: LogTypes;
  feature: string;
  event: string;
  description: string;
  level?: LogLevels;
  watchKeyOrDuration?: any;
}
